import { Duration } from '@components/search/duration/Duration';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DealFinderState } from '@model/state';
import { getDealFinderState } from '@state/slices/deal-finder/dealFinderSelectors';
import { setDuration } from '@state/slices/deal-finder/dealFinderSlice';

export interface DurationContainerProps {
  tabsRef: any;
  isCondensed: boolean;
}

export const DurationContainer = ({ tabsRef, isCondensed }: DurationContainerProps) => {
  const dispatch = useDispatch();
  const dealFinder: DealFinderState = useSelector(getDealFinderState);
  const handleOnChange = (duration: number) => dispatch(setDuration(duration));

  return (
    <Duration tabsRef={tabsRef} duration={dealFinder.duration} onChange={handleOnChange} isCondensed={isCondensed} />
  );
};
